import _ from 'lodash'

import { FramesManager } from '../../../view/frames-manager'

interface FieldPathSource {
  frames?: FramesManager
  /** Present on components bound to a transient variable rather than an entity path. */
  transientValue?: string
}

/**
 * The key a bound ui2 component registers with FormFocusTargetContext.
 *
 * Must match `mergeUIStateErrors` (shared-libs entity/renderer.tsx): for a
 * component bound to a transient variable the error key is the transient name,
 * not the entity valuePath — so a registration using the valuePath there can
 * never be resolved by `focusFirstError`.
 *
 * Shared because the field shell is no longer the only thing that registers;
 * components that render without a shell (`ui2:geolocationField`) still have
 * to arrive at the same key.
 */
export function resolveBoundFieldPath(props: FieldPathSource): string | undefined {
  const transientValue = (props as any).transientValue
  if (typeof transientValue === 'string' && transientValue.length > 0) {
    return transientValue
  }
  const valuePath: any = props.frames?.getContext?.('valuePath')
  if (!_.isArray(valuePath) || _.isEmpty(valuePath)) return undefined
  return valuePath.join('.')
}
